(function($) {
	"use strict";

	let utils;
	let toast;
	let requestTimestamp;
	
	function init() {
		utils = Fw.component.models().utils;
		toast = Fw.component.models().toast;

		$('.com-webconferences__filters .pill-filter__input').on('change', onPillChange);
	}

	function onPillChange({ currentTarget }) {
		let $elem = $(currentTarget);
		let $com = $elem.closest('.com-webconferences');
		if (currentTarget.name == 'addTextField5') {
			$('[name="addTextField5"]').not($elem).prop('checked', false);
		}

		fetchUpdatedCatalog($com);
	}

	function fetchUpdatedCatalog($com) {
		let params = utils.getParamsMap();
		let $inner = $com.find('.com-webconferences__inner');
		let currentTimestamp = new Date();
		let $items = $com.find('.pill-filter__input');
		let names = $items.map((i, el) => el.name).get();
		let newUrl = `${location.href.split('?')[0]}`;
		requestTimestamp = currentTimestamp;

		for (let param in params) {
			let queryJoiner = newUrl.indexOf('?') !== -1 ? '&' : '?';
			if (names.indexOf(param) == -1 && param != 'page') {
				newUrl += `${queryJoiner}${param}${params[param].length ? '=' : ''}${params[param]}`;
			}
		}

		$items.filter(':checked').each((i, el) => {
			let queryJoiner = newUrl.indexOf('?') !== -1 ? '&' : '?';
			newUrl += `${queryJoiner}${el.name}=${el.value}`;
		});

		$inner.addClass('has-processing has-processing_active');
		utils.fetchPortionOfSite(newUrl, '.com-webconferences__inner')
			.then($newInner => {
				if (requestTimestamp == currentTimestamp) {
					$inner.html($newInner.html());
					$inner.removeClass('has-processing has-processing_active');
					history.replaceState({}, document.title, newUrl);
				}
			})
			.catch((e) => {
				console.error(e);
				toast.create(
					document.documentElement.lang === 'fr' ? 'Il y a eu une erreur. Veuillez réessayer.' : 'There was an error. Please try again.',
					toast.DURATION.LONG
				);
				$inner.removeClass('has-processing has-processing_active');
			});
	}
	
	$(init);
	
})(jQuery);